import { Radio } from "lucide-react";

const BG = "https://static.prod-images.emergentagent.com/jobs/959bc689-4b30-4d46-a7b6-d235dee99ca2/images/3419c176f670bf61b6eb30c63944b0d24a6ff5fd6ba44fa14e75c827f133667b.jpeg";

export const AuthHero = () => (
  <div className="relative hidden lg:block overflow-hidden border-r border-border" data-testid="auth-hero">
    <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-80" />
    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
    <div className="relative z-10 h-full flex flex-col justify-between p-12">
      <div className="flex items-center gap-2">
        <div className="w-9 h-9 bg-[#007AFF] flex items-center justify-center">
          <Radio className="w-5 h-5 text-white" />
        </div>
        <span className="font-heading font-black text-xl tracking-tighter">Incident Tracking &amp; Inquiry Services</span>
      </div>
      <div>
        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter leading-none mb-4">
          Every call.<br />Every incident.<br />
          <span className="text-[#007AFF]">On the record.</span>
        </h1>
        <p className="text-muted-foreground max-w-md">
          Voice-agent reports, transcripts, and recordings — captured by phone, filed to your account, ready to review.
        </p>
      </div>
    </div>
  </div>
);
